import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const [state, setState] = useState({
    token: null,
    userId: null,
    role: null,
    account: null,
    isLoggedIn: false,
  });

  const navigate = useNavigate();

  const signin = async (userId, token, role, account) => {
    setState({
      token: token,
      userId: userId,
      role: role,
      account: account,
      isLoggedIn: true,
    });

    localStorage.setItem(
      "UserData",
      JSON.stringify({
        token: token,
        userId: userId,
        role: role,
        account: account,
      })
    );
  };

  const signout = () => {
    setState({
      token: null,
      userId: null,
      role: null,
      isLoggedIn: false,
      account: null,
    });

    localStorage.removeItem("UserData");
  };

  const changeAccount = (new_account_id, callback) => {
    setState({ ...state, account: new_account_id });
    callback();
  };

  return (
    <AuthContext.Provider
      value={{
        state,
        signin,
        signout,
        changeAccount,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
